import { createFileRoute, Link, Outlet, redirect, useRouter } from '@tanstack/react-router';
import { api } from '@/lib/api';
import { clearSession, getSessionUser, setSession, type SessionUser } from '@/lib/session';
import { Button } from '@/components/ui/button';

export const Route = createFileRoute('/app')({
  beforeLoad: async () => {
    if (getSessionUser()) return;
    try {
      const result = await api.post<{ accessToken: string; user: SessionUser }>('/v1/auth/refresh');
      setSession(result.accessToken, result.user);
    } catch {
      throw redirect({ to: '/login' });
    }
  },
  component: AppShell,
});

function AppShell() {
  const router = useRouter();
  const user = getSessionUser();

  async function handleLogout() {
    try {
      await api.post<void>('/v1/auth/logout');
    } catch (err) {
      console.error(err);
    }
    clearSession();
    void router.navigate({ to: '/login' });
  }

  return (
    <div className="min-h-screen bg-background">
      <nav className="sticky top-0 z-10 border-b border-border bg-background px-6 py-3 flex items-center gap-4">
        <Link to="/app/dashboard" className="flex items-center">
          <img src="/mt-logo.png" alt="Mowing Tracker" className="h-8 w-auto" />
        </Link>
        <Link
          to="/app/dashboard"
          className="text-sm transition-colors"
          activeProps={{ className: 'font-medium text-foreground' }}
          inactiveProps={{ className: 'text-muted-foreground hover:text-foreground' }}
        >
          Properties
        </Link>
        <div className="flex-1" />
        {user && (
          <Link
            to="/app/account"
            className="text-sm transition-colors"
            activeProps={{ className: 'font-medium text-foreground' }}
            inactiveProps={{ className: 'text-muted-foreground hover:text-foreground' }}
          >
            {user.displayName}
          </Link>
        )}
        <Button variant="ghost" size="sm" onClick={() => { void handleLogout(); }}>
          Logout
        </Button>
      </nav>
      <main className="p-6">
        <Outlet />
      </main>
    </div>
  );
}
